/* eslint-disable @typescript-eslint/no-unused-vars */
// import React, { useContext } from 'react';
import { Route, Routes } from 'react-router-dom';
// import { AuthContext } from './contexto/Auth/AuthContext';
import { RequireAuth } from './context/Auth/RequireAuth';
import MainLayout from './layout/Main/MainLayout';
import MainSiteLayout from './layout/MainSite/MainSite';
import Erro from './pages/erro404/Erro';
import Login from './pages/login/Login';
import { routes, routesSites } from './routes';
import { useState } from 'react';
import { LoadingProvider } from './context/Loading/LoadingContext';
import Loading from './components/Loading/Loading.component';
import CloneProduto from './pages/editProduto/EditProduto';
import { CarrinhoProvider } from './context/Carrinho/CarrinhoContext';
import React from 'react';

function App() {
  // const auth = useContext(AuthContext);

  return (
    <LoadingProvider>
      <Loading />
      <CarrinhoProvider>
        <Routes>
          <Route path="/" element={<Login />} />

          <Route
            path="/vendedor"
            element={
              <RequireAuth>
                <MainSiteLayout />
              </RequireAuth>
            }
          >
            {routesSites}
          </Route>

          <Route
            path="/admin"
            element={
              <RequireAuth>
                <MainLayout />
              </RequireAuth>
            }
          >
            {routes}
          </Route>

          <Route path="*" element={<Erro />} />
        </Routes>
      </CarrinhoProvider>
    </LoadingProvider>
  );
}

export default App;
